<template>
  <div class="m-live-widgets">
    <div
      v-show="trackerVisible || playerVisible"
      class="m-live-widgets-contianer"
    >
      <LivePlayer
        v-if="!!matchInfo.hasLive && playerVisible"
        :event-id="eventId"
        :event="matchInfo"
      />
      <!-- live match tracker -->
      <div
        v-if="trackerVisible"
        ref="trackerWrap"
        class="m-live-tracker-wrap"
        :style="{
          opacity: opacity
        }"
        @touchstart="onTouchstart"
        @touchmove="onTouchmove"
        @touchend="onTouchend"
      >
        <Widgets
          v-if="matchInfo.sportId"
          name="lmtPlus"
          :sport-id="matchInfo.sportId"
          :event="matchInfo"
          :event-id="eventId"
          no-tips
          @mount="onWidgetMount"
        />
      </div>
    </div>

    <div class="m-btns">
      <a
        v-if="!!matchInfo.hasLive"
        class="m-btn"
        :class="{
          'active': playerVisible
        }"
        @click="handleLiveStream"
      >
        <svg-icon icon-class="icon-video" />
        <span>Live Stream</span>
      </a>

      <a
        v-if="isSupportTracker"
        class="m-btn x-link-active"
        :class="{
          'active': trackerVisible
        }"
        @click="toggleShowTracker"
      >
        <svg-icon icon-class="icon-match-tracker" />
        <span>Match Tracker</span>
      </a>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@ms/stores/auth'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import Widgets from 'base/components/Widgets'
import LivePlayer from 'base/components/LivePlayer'
import { throttle } from 'throttle-debounce'
import { checkSupportLiveMatchTracker } from '@ms/components/widgets/check.js'
import useMatchInfo from '@ms/components/match/useMatchInfo.js'
import 'base/icons/svg/video.svg'
import 'base/icons/svg/match-tracker.svg'

// tracker 置顶开关，当前状态关闭后不再置顶
let flag = false
// 暂时先放这里吧
window.isMobile = /Android|iPhone|iPad|iPod|iOS|BlackBerry/i.test(navigator.userAgent)

export default {
  name: 'LiveWidgets',
  components: {
    Widgets,
    LivePlayer
  },
  props: {
    eventId: {
      type: String,
      default: ''
    }
  },
  setup() {
    const { matchInfo } = useMatchInfo()
    const matchDetailStore = useMatchDetailStore()
    const { isCommentary } = storeToRefs(matchDetailStore)

    return {
      matchInfo,
      isCommentary
    }
  },
  data() {
    return {
      trackerVisible: false,
      playerVisible: false,
      opacity: 1,
      padDiv: null,
      padDivHeight: 0
    }
  },
  computed: {
    isSupportTracker() {
      return checkSupportLiveMatchTracker(this.matchInfo.sportId)
    }
  },
  watch: {
    eventId() {
      this.trackerVisible = this.playerVisible = false
    }
  },
  mounted() {
    // 每次进入可以置顶
    flag = false
  },
  beforeDestroy() {
    window.isMobile && window.removeEventListener('scroll', this.scrollListener)
  },
  methods: {
    handleLiveStream() {
      this.toggleShowLiveStream()
      window.mstrace('LiveMatchDetail_Stream')
    },
    toggleShowLiveStream() {
      if (!useAuthStore().loginStatus) {
        return this.$login({
          onSuccess: () => {
            this.toggleShowLiveStream()
          }
        })
      }
      const visible = !this.playerVisible
      this.playerVisible = visible
      if (visible) {
        this.trackerVisible = false
      }
      this.$emit('active', this.playerVisible)
    },
    toggleShowTracker() {
      const visible = !this.trackerVisible
      this.trackerVisible = visible
      if (visible) {
        this.playerVisible = false
      }
      this.$emit('active', this.trackerVisible)

      if (visible) {
        this.$nextTick(() => {
          this.createTrackerPadDiv()
        })
        if (window.isMobile) {
          window.addEventListener('scroll', this.scrollListener, false)
        }
      } else {
        window.isMobile && this.resetTrackerStyle()
      }
      window.mstrace('LiveMatchDetail_tracker')
    },
    createTrackerPadDiv() {
      if (!this.padDiv) {
        const el = this.$refs.trackerWrap
        const padDiv = document.createElement('div')
        // 占位空白的宽高
        padDiv.style.width = `${el.clientWidth}px`
        padDiv.style.height = `${el.clientHeight}px`
        padDiv.style.display = 'none'
        el.parentNode.insertBefore(padDiv, el)
        this.padDiv = padDiv
      }
    },
    onWidgetMount() {
      this.$nextTick(() => {
        const el = this.$refs.trackerWrap
        this.padDiv.style.width = `${el.clientWidth}px`
        this.padDiv.style.height = `${el.clientHeight}px`
        this.padDivHeight = el.clientHeight
      })
    },
    scrollListener() {
      if (flag) {
        return
      }
      return throttle(100, () => {
        if (!this.trackerVisible) return
        const el = this.$refs.trackerWrap
        if (el.clientHeight > this.padDivHeight) {
          this.padDiv.style.height = `${el.clientHeight}px`
          this.padDivHeight = el.clientHeight
        }
        const isFixed = el.dataset.fixed === '1'
        const ele = isFixed ? this.padDiv : el // 确定是否在视图内的元素
        const rect = ele.getBoundingClientRect()
        if (rect.top <= -rect.height) {
          // 置顶
          if (el.dataset.fixed === '1') {
            return
          }
          this.padDiv.style.display = 'block'
          el.classList.add('fixed')
          el.style.top = this.isCommentary ? '44px' : '88px'
          const classList = el.classList
          if (!classList.contains('scale')) {
            // 切换成第一个 tab
            const firstTab = document.querySelector('.sr-lmt-plus .sr-lmt-plus-tabs__tab')
            const vFirstTab = document.querySelector('.v-tracker-menu-match')
            if (firstTab || vFirstTab) {
              if (this.matchInfo.sportId === 'lv:sport:1') {
                document.querySelector('.v-tracker-menu-match').click()
              } else {
                document.querySelector('.sr-lmt-plus .sr-lmt-plus-tabs__tab').click()
              }
            }
            classList.add('scale')
          }
          el.dataset.fixed = '1'
        } else {
          // 移除置顶
          el.classList.remove('scale')
          if (!el.dataset.fixed) {
            return
          }
          // 移除占位空白
          if (this.padDiv) {
            this.padDiv.style.display = 'none'
          }
          if (el.style.transform) {
            el.style.webkitTransform = null
            el.style.transform = null
          }
          el.classList.remove('fixed')
          delete el.dataset.fixed
        }
      })()
    },
    onTouchstart(e) {
      if (!this.$refs.trackerWrap.classList.contains('scale')) {
        return
      }
      e.preventDefault()
      this.opacity = 1
      const el = this.$refs.trackerWrap
      if (el.style.transition) {
        el.style.transition = null
      }
      const touch = e.targetTouches[0]
      if (!this._startX) {
        this._startX = touch.clientX
      }
      if (!this._startY) {
        this._startY = touch.clientY
      }
    },
    onTouchmove(e) {
      if (!this.$refs.trackerWrap.classList.contains('scale')) {
        return
      }
      e.preventDefault()
      const touch = e.targetTouches[0]
      const el = this.$refs.trackerWrap
      const left = touch.clientX - this._startX
      const top = touch.clientY - this._startY
      el.style.webkitTransform = `translate3d(${left}px, ${top}px, 0) scale(0.55)`
      el.style.transform = `translate3d(${left}px, ${top}px, 0) scale(0.55)`
      this.opacity = 1 - Math.sqrt(left * left + top * top) / 150
      if (this.opacity < 0.2) {
        this.resetTrackerStyle()
        this.forbidSticky()
      }
    },
    onTouchend(e) {
      if (!this.$refs.trackerWrap.classList.contains('scale')) {
        return
      }
      e.preventDefault()
      // 1/3 即删除
      if (this.opacity < 0.66) {
        this.resetTrackerStyle()
        this.forbidSticky()
      } else {
        const el = this.$refs.trackerWrap
        if (el.style.transform) {
          el.style.webkitTransform = 'translate3d(0, 0, 0) scale(0.55)'
          el.style.transform = 'translate3d(0, 0, 0) scale(0.55)'
        }
        this.opacity = 1
      }
    },
    resetTrackerStyle() {
      const el = this.$refs.trackerWrap
      if (this.padDiv) {
        this.padDiv.parentNode.removeChild(this.padDiv)
        this.padDiv = null
      }
      el.classList.remove('scale', 'fixed')
      el.style.transform = null
      this.opacity = 1
    },
    forbidSticky() {
      flag = true
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-live-widgets {
  padding: 8px 0 10px;
  border-radius: 0 0 20px 20px;
  margin-bottom: 5/@rem;
  background:#161616;
  color: #ccc;
  font-size: 12/@rem;
  line-height: 16/@rem;
  text-align: right;

  .m-live-widgets-contianer {
    margin: 5/@rem 0 15/@rem;
  }

  .m-btns {
    padding: 0 16px;
  }

  .m-btn {
    display: inline-block;
    height: 26px;
    padding: 0 9px;
    border: 1px solid @primary;
    border-radius:14px;
    margin-left: 10/@rem;
    color: @primary;
    line-height: 26px;
    vertical-align: top;

    &.active {
      background: @primary;
      color: #333;

      .svg-icon {
        color: #333;
      }
    }

    & > span,
    i {
      vertical-align: top;
    }

    .svg-icon {
      margin-right: 2px;
      margin-bottom: 1px;
      color: @primary;
      font-size: 20px;
    }
  }

  .m-live-tracker-wrap {
    &.fixed {
      position: fixed;
      z-index: 1001;
      top: 0;
      width: 91.67%;
      transform-origin: right 0;

      .m-widgets .sr-lmt-plus-tabs,
      .sr-ad__banner,
      .sr-lmt-plus__footer-wrapper {
        display: none !important;
      }

      .v-tracker-menu {
        display: none !important;
      }

      .v-tracker {
        padding-bottom: 0 !important;
      }
    }

    &.scale {
      top: 44px;
      right: 0;
      transform: scale(0.55);

      &::after {
        position: absolute;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: "";
      }
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .m-live-widgets {
  background:#fff;

  .m-btn {
    border: 1px solid #ff7d1e;
    color: #ff7d1e;

    &.active {
      background: #ff7d1e;
      color: #fff;

      .svg-icon {
        color: #fff;
      }
    }
  }

  .svg-icon {
    color: #ff7d1e;
  }
}
</style>